const PROVINCES = [
    {
        value: 'ab',
        transKey: 'FINANCING.RESIDENCE_INFOS.PROVINCES.ALBERTA',
    },
    {
        value: 'bc',
        transKey: 'FINANCING.RESIDENCE_INFOS.PROVINCES.BRITISH_COLUMBIA',
    },
    {
        value: 'mb',
        transKey: 'FINANCING.RESIDENCE_INFOS.PROVINCES.MANITOBA',
    },
    {
        value: 'nb',
        transKey: 'FINANCING.RESIDENCE_INFOS.PROVINCES.NEW_BRUNSWICK',
    },
    {
        value: 'nl',
        transKey: 'FINANCING.RESIDENCE_INFOS.PROVINCES.NEW_FOUNDLAND',
    },
    {
        value: 'ns',
        transKey: 'FINANCING.RESIDENCE_INFOS.PROVINCES.NOVA_SCOTIA',
    },
    {
        value: 'on',
        transKey: 'FINANCING.RESIDENCE_INFOS.PROVINCES.ONTARIO',
    },
    {
        value: 'pe',
        transKey: 'FINANCING.RESIDENCE_INFOS.PROVINCES.PRINCE_EDWARD',
    },
    {
        value: 'qc',
        transKey: 'FINANCING.RESIDENCE_INFOS.PROVINCES.QUEBEC',
    },
    {
        value: 'sk',
        transKey: 'FINANCING.RESIDENCE_INFOS.PROVINCES.SASKATCHEWAN',
    },
];

const STREET_TYPES = [
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_TYPES.ALLEY',
        value: 'AL',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_TYPES.AVENUE',
        value: 'AV',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_TYPES.BOULEVARD',
        value: 'BV',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_TYPES.MOUNT',
        value: 'MO',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_TYPES.PATH',
        value: 'PA',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_TYPES.PATHWAY',
        value: 'PW',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_TYPES.PARKWAY',
        value: 'PY',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_TYPES.PLACE',
        value: 'PL',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_TYPES.ROAD',
        value: 'RD',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_TYPES.STREET',
        value: 'ST',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_TYPES.TRAIL',
        value: 'TR',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_TYPES.WAY',
        value: 'WY',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_TYPES.OTHER',
        value: 'OT',
    },
];

export { STREET_TYPES, PROVINCES };
export default {
    STREET_TYPES,
    PROVINCES,
};
